import { connect } from 'react-redux';
import React from 'react';
import { Table } from '@kaleyra/emmy';
import { IColumn } from '@kaleyra/emmy/dist/molecules/styledTable';
import i18n from 'i18next';
import { Instances } from '../../../constants';
import Styles from './index.module.scss';

import {
	makeSelectCount,
	makeSelectObjectsArray,
	makeSelectOffset,
	requestObjects,
	changeOffset,
	makeSelectInProgress,
} from '../../../store/Objects';
import { IStateType } from '../../../store/models/root.interface';

type MapStateToPropsType = {
	data: Array<any>;
	page: number;
	total: number;
	inProgress: boolean;
};

type DispatchToProps = {
	onPaginate: () => void;
	onLoad: (
		filters: Record<string, any>,
		searchTerm: string,
		property: string
	) => void;
};

type SelfProps = {
	columns: Array<IColumn>;
	filters: Record<string, any>;
	searchTerm?: string;
	property?: string;
};

const TableTemplate: React.FC<
	MapStateToPropsType & DispatchToProps & SelfProps
> = ({
	data,
	page,
	total,
	filters,
	searchTerm = 'search',
	inProgress,
	onPaginate,
	onLoad,
	columns,
	property = '',
}) => {
		React.useEffect(() => {
			onLoad(filters, searchTerm, property);
		}, []);

		return (
			<Table
				columns={columns}
				data={data}
				page={page + 1}
				pageSize={25}
				manual
				onPaginate={onPaginate}
				total={total}
				scrollableTarget={'modalContainer'}
				inProgress={inProgress}
				rowClassName={Styles.tableRow}
				labelForNoResult={i18n.t('tableNoResults')}
				labelForNoResultDesc={i18n.t('tableNoResultsDesc')}
			/>
		);
	};

const TableFactory = (instanceId: Instances) => {
	const mapStateToProps = () => {
		const selectData = makeSelectObjectsArray(instanceId);
		const selectPage = makeSelectOffset(instanceId);
		const selectTotal = makeSelectCount(instanceId);
		const selectInProgress = makeSelectInProgress(instanceId);

		return (state: IStateType) => ({
			data: selectData(state),
			page: selectPage(state),
			total: selectTotal(state),
			inProgress: selectInProgress(state),
		});
	};

	const mapDispatchToProps = {
		onLoad: (
			filters: Record<string, any>,
			searchTerm: string,
			property: string
		) => requestObjects(instanceId, filters, { searchTerm, property }),
		onPaginate: () => changeOffset(instanceId),
	};

	return connect<MapStateToPropsType, DispatchToProps, SelfProps, IStateType>(
		mapStateToProps,
		mapDispatchToProps
	)(TableTemplate);
};

export default TableFactory;
